__turbopack_context__.v({
  "container": "SectionCarousel-module-sass-module__JhWNFG__container",
  "header": "SectionCarousel-module-sass-module__JhWNFG__header",
  "kuper-header": "SectionCarousel-module-sass-module__JhWNFG__kuper-header",
  "kuper-icon": "SectionCarousel-module-sass-module__JhWNFG__kuper-icon",
  "kuper-info": "SectionCarousel-module-sass-module__JhWNFG__kuper-info",
  "kuper-info-button": "SectionCarousel-module-sass-module__JhWNFG__kuper-info-button",
  "kuper-info-popup": "SectionCarousel-module-sass-module__JhWNFG__kuper-info-popup",
  "title": "SectionCarousel-module-sass-module__JhWNFG__title",
});
